import { ModelBase } from "./model";

class UserCourseStatus extends ModelBase {
  static namespace = 'user_course_status';

  static cache = false;
}
export default UserCourseStatus.register();
